import axios from "axios";
import config from "../../config";

/**
 * Generic function to send data to Google Sheets via Apps Script
 *
 * @param {Object} data - Data object to send
 * @param {String} appsScriptUrl - Apps Script Web App URL
 * @returns {Promise}
 */
const sendToGoogleSheets = async (data, appsScriptUrl) => {
  // Check if URL is configured
  if (!appsScriptUrl || appsScriptUrl === "YOUR_APPS_SCRIPT_WEB_APP_URL_HERE") {
    console.warn(
      "Google Sheets Apps Script URL not configured. Please update the URL in /src/constants/index.js"
    );
    return { status: "error", message: "Apps Script URL not configured" };
  }

  // Add timestamp to the data
  const dataWithTimestamp = {
    Timestamp: new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }),
    ...data,
  };

  try {
    const response = await axios.post(appsScriptUrl, dataWithTimestamp, {
      headers: {
        "Content-Type": "application/json",
      },
      // Add timeout to prevent hanging
      timeout: 10000,
    });

    console.log("Data sent to Google Sheets successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error sending data to Google Sheets:", error);

    // If CORS error, try alternative method using fetch with no-cors mode
    if (
      error.message.includes("Network Error") ||
      error.message.includes("CORS")
    ) {
      console.log("Attempting alternative method due to CORS...");
      try {
        // Use fetch with no-cors mode as fallback
        await fetch(appsScriptUrl, {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataWithTimestamp),
        });
        console.log("Data sent to Google Sheets via fallback method");
        return { status: "success", message: "Data sent (no-cors mode)" };
      } catch (fetchError) {
        console.error("Fallback method also failed:", fetchError);
      }
    }

    // Don't throw error to prevent form submission failure
    // The data is already sent to LeadSquared, so this is a backup
    return { status: "error", message: error.message };
  }
};

/**
 * Send Diabetes Consultation form data to Google Sheets
 *
 * @param {Object} leadSquaredParams - LeadSquared parameters object
 * @returns {Promise}
 */
export const sendDiabetesConsultDataToSheets = async leadSquaredParams => {
  return sendToGoogleSheets(
    leadSquaredParams,
    config.DIABETES_CONSULT_FORM_SCRIPT_URL
  );
};

/**
 * Send Metabolism Assessment form data to Google Sheets
 *
 * @param {Object} leadSquaredParams - LeadSquared parameters object
 * @returns {Promise}
 */
export const sendMetabolismAssessmentDataToSheets = async leadSquaredParams => {
  return sendToGoogleSheets(
    leadSquaredParams,
    config.METABOLIC_QUIZ_FORM_SCRIPT_URL
  );
};
